export const ru = {
    'CollectionDefectIds.Gen.CANNOT_BE_EMPTY': 'Не выбран параметр "Где искать"',
    'DefectIds.NO_RIGHTS': 'Нет прав для выполнения данной операции',
    'GdExceptions.ACCESS_DENIED': 'Нет прав для просмотра данной страницы',
    'GdExceptions.NO_RIGHTS': 'Нет прав для выполнения данной операции',
    'GdExceptions.TYCOON_SERVICE_UNAVAILABLE': 'Что-то пошло не так. Проблема с получением данных от Я.Справочника',
    'KeywordDefectIds.Gen.NO_RIGHTS_IN_ARCHIVED_ADGROUP':
        'Невозможно заменить слова в архивных группах: {validationResultValue}',
    'KeywordDefectIds.Keyword.MAX_KEYWORDS_PER_AD_GROUP_EXCEEDED': 'Достигнут максимум фраз в группе:{maxKeywords}',
    'PhraseDefectIds.Gen.BOTH_QUOTES_AND_MINUS_WORDS': 'Словосочетание в кавычках не может состоять из минус-слов',
    'PhraseDefectIds.Gen.INVALID_EXCLAMATION_MARK': 'Минус слова содержат недопустимые символы',
    'PhraseDefectIds.Gen.INVALID_MINUS_MARK': 'Минус слова содержат недопустимые символы',
    'PhraseDefectIds.Gen.INVALID_PLUS_MARK': 'Фразы содержат недопустимые символы',
    'PhraseDefectIds.Gen.NO_PLUS_WORDS': 'Замена невозможна: полностью удаляется ключевая фраза',
    'PhraseDefectIds.String.ILLEGAL_CHARACTERS': 'Введены недопустимые символы: {allInvalidSubstrings}',
    'PhraseDefectIds.String.NOT_SINGLE_MINUS_WORD':
        'Из ключевой фразы могут вычитаться только отдельные слова, а не словосочетания: {phrase}',
    'PhraseDefectIds.String.TOO_LONG_MINUS_WORD':
        'Ограничение длины длина минус-слова - {maxLength}. Минус-слово {allInvalidSubstrings} слишком длинное.',
    'PhraseDefectIds.String.TOO_LONG_WORD':
        'Ограничение длины фразы - {maxLength}. Фраза "{allInvalidSubstrings}" слишком длинная.',
    'PhraseDefectIds.String.TOO_MANY_WORDS': 'Максимальное количества слов в фразе - {maxWords}',
    'StringDefectIds.CANNOT_BE_EMPTY': 'Замена невозможна: полностью удаляется ключевая фраза',
    'phrase-only-stop-words': 'Ключевая фраза не может состоять только из стоп-слов (союзов, предлогов, частиц)',
    'unknown-error': 'Непредвиденная ошибка',
    'unknown-error-title': 'Что-то пошло не так'
};
